import Index from "../../../Index";
import PagesIndex from "../../../PagesIndex";
import {
  DonnerlistAdd,
  getSahaylist,
  getSahaySubTypeList,
  getSahayTypeList,
  subSahaylistAdd,
  subSahaylistEdit,
} from "../../../../redux/features/AddService";
// import "./Subsahaytype.css";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

const DonnerTypeAdd = () => {
  //useselector
  // const getSahaydata = PagesIndex.useSelector(
  //   (state) => state.admin.getSahaydata
  // );

  //navigate dispatch uselocation
  const navigate = PagesIndex.useNavigate();
  const dispatch = PagesIndex.useDispatch();
  const { state } = PagesIndex.useLocation();
  const [subSahayExist, setSubSahayExist] = useState("");
  const [sahaytypeMasterlist, setSahaytypeMasterlist] = useState([]);
  const [sahayTypeList, setSahayTypeList] = useState();
  const [sahaySubTypeList, setSahaySubTypeList] = useState();

  const rollData = JSON.parse(localStorage?.getItem("RollName"))?.toLowerCase();
  //get edit data in list
  const editData = state?.row;


  //initialValues
  let initialValues = {
    DonnerName: editData ? editData?.DonnerName : "",
    SahayCategory: editData ? editData?.sahayCategoryId : "",
    SubSahayType: editData ? editData?.subSahayId
      : "",
    isSubmit: false,
  };

  //handle submit
  const handleFormSubmit = (values, { setFieldValue }) => {
    setFieldValue("isSubmit", true);
    // if (editData?.id) {
    //   let updatedata = {
    //     id: editData?.id,
    //     DonnerName: values?.DonnerName,
    //     SahayCategory: values?.SahayCategory,
    //     SubSahayType: values?.SubSahayType
    // };
    //   dispatch(DonnerlistAdd(updatedata)).then((res) => {
    //     if (res?.payload == 200) {
    //       navigate(`/${rollData}/donnertype-master`);
    //       setTimeout(() => {
    //         setFieldValue("isSubmit", false);
    //       }, 1000);
    //     } else {
    //       setTimeout(() => {
    //         setFieldValue("isSubmit", false);
    //       }, 1000);
    //     }
    //     if (res?.payload?.status == 409) {
    //       setSubSahayExist(res?.payload?.message);
    //     } else {
    //       setSubSahayExist("");
    //     }
    //   });
    // } else {

    if (editData?.id) {
      values.id = editData.id;
    }

    dispatch(DonnerlistAdd(values)).then((res) => {
      if (res?.payload == 201 || res?.payload == 200) {
        navigate(`/${rollData}/donnertype-master`);
        setTimeout(() => {
          setFieldValue("isSubmit", false);
        }, 1000);
      } else {
        setTimeout(() => {
          setFieldValue("isSubmit", false);
        }, 1000);
      }
      if (res?.payload?.status == 409) {
        setSubSahayExist(res?.payload?.message);
      } else {
        setSubSahayExist("");
      }
    });
    // }
  };

  // useEffect(() => {
  //   dispatch(getSahaylist()).then((res) => {
  //     if (res?.payload?.status === 200) {
  //       setSahaytypeMasterlist(res?.payload?.data);
  //     }
  //   });
  // }, []);
  const getSahayTypeData = () => {
    dispatch(getSahayTypeList()).then((res) => {
      setSahayTypeList(res?.payload);
    });
  };

  const getSahaySubTypeData = (sahayTypeId) => {

    dispatch(getSahaySubTypeList(sahayTypeId)).then((res) => {
      setSahaySubTypeList(res?.payload);
    });
  };

  useEffect(() => {
    getSahayTypeData();

  }, []);
  useEffect(() => {
    getSahaySubTypeData(editData?.sahayCategoryId);

  }, [editData?.sahayCategoryId]);


  const { rollPermissionData } = useSelector((state) => state.admin);
  const rollPermissionNameData =
    rollPermissionData?.findData?.parentRoleName?.toLowerCase();

  if (
    rollPermissionData?.permissionArray?.includes(
      "Sub Sahay Type Master_add"
    ) ||
    rollPermissionData?.permissionArray?.includes("Sub Sahay Type Master_edit") || rollPermissionNameData === "admin"
  ) {
  } else {
    navigate(`/${rollData}/sahay-application`);
  }

  return (
    <>
      <Index.Box className="page-content-box">
        <Index.Box className="barge-common-box">
          <Index.Box className="title-header">
            <Index.Box className="title-header-flex">
              <Index.Box className="title-main mb-10">
                <Index.Typography
                  variant="p"
                  component="p"
                  className="page-title"
                >
                  {state ? state?.edit : "Add"} Donner Name
                </Index.Typography>
              </Index.Box>
            </Index.Box>
          </Index.Box>

          <PagesIndex.Formik
            enableReinitialize
            onSubmit={handleFormSubmit}
            initialValues={initialValues}
            validationSchema={PagesIndex.validationSchemaDonnerTypeMaster}
          >
            {({
              values,
              handleChange,
              handleSubmit,
              errors,
              handleBlur,
              touched,
              isSubmitting,
              setFieldValue,
            }) => (
              <form onSubmit={handleSubmit}>
                <Index.Box className="">
                  <Index.Grid container spacing={2}>
                    <Index.Grid item xs={12} sm={6} md={3}>
                      <Index.Typography
                        variant="label"
                        component="label"
                        className="input-label"
                      >
                        Sahay Type(શાખાનો પ્રકાર)*
                      </Index.Typography>
                      <Index.Box className="input-design-div with-border">
                        <Index.Select
                          fullWidth
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          value={values.SahayCategory}
                          name="SahayCategory"
                          onBlur={handleBlur}
                          onChange={(e) => {
                            handleChange(e);
                            getSahaySubTypeData(e.target.value);
                          }}

                        >
                          {sahayTypeList?.map((datas) => (
                            <Index.MenuItem
                              key={datas?.Id}
                              // name={datas?.Sahay_category}
                              value={datas?.Id}
                            >
                              {datas?.Sahay_category}
                            </Index.MenuItem>
                          ))}
                        </Index.Select>

                        <Index.FormHelperText></Index.FormHelperText>
                      </Index.Box>
                      {errors?.SahayCategory && touched.SahayCategory && (
                        <p className="error-text">{errors?.SahayCategory}</p>
                      )}
                    </Index.Grid>
                    <Index.Grid item xs={12} sm={6} md={3}>
                      <Index.Typography
                        variant="label"
                        component="label"
                        className="input-label"
                      >
                        Sub Sahay Type(સબ સહાય પ્રકાર)*
                      </Index.Typography>
                      <Index.Box className="input-design-div with-border">
                        <Index.Select
                          fullWidth
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          value={values.SubSahayType}
                          name="SubSahayType"
                          onBlur={handleBlur}
                          onChange={handleChange}
                        >
                          {sahaySubTypeList?.map((ele) => (
                            <Index.MenuItem
                              key={ele?.Id}
                              value={ele?.Id}
                            >
                              {ele?.SahayName}
                            </Index.MenuItem>
                          ))}
                        </Index.Select>

                        <Index.FormHelperText></Index.FormHelperText>
                      </Index.Box>
                      {errors?.SubSahayType && touched.SubSahayType && (
                        <p className="error-text">{errors?.SubSahayType}</p>
                      )}
                    </Index.Grid>
                    <Index.Grid item xs={12} sm={6} md={3}>
                      <Index.Typography
                        variant="label"
                        component="label"
                        className="input-label"
                      >
                        Donner Name (દાતા નામ)*
                      </Index.Typography>
                      <Index.Box className="input-design-div with-border">
                        <Index.TextField
                          name="DonnerName"
                          value={values.DonnerName}
                          hiddenLabel
                          onBlur={handleBlur}
                          onChange={(e) => {
                            const inputValue = e.target.value;
                            if (inputValue == "") {
                              setSubSahayExist("");
                            }
                            setFieldValue("DonnerName", inputValue);
                          }}
                          id="filled-hidden-label-normal"
                          placeholder="Enter Sub Sahay Type"
                          variant="filled"
                          className="admin-input-design input-placeholder"
                          autoComplete="off"
                        />
                      </Index.Box>
                      {errors?.DonnerName && touched.DonnerName && (
                        <p className="error-text">{errors?.DonnerName}</p>
                      )}
                      {subSahayExist !== "" && values?.DonnerName !== "" && (
                        <p className="error-text">{subSahayExist}</p>
                      )}
                    </Index.Grid>

                    <Index.Grid item xs={12} sm={12} md={3} lg={3}>
                      <Index.Box
                        // mt={3}
                        // ml={3}
                        className="common-button blue-button flex-start save-btn custom-space-details text-btn-end-ipad"
                      >
                        <Index.Button
                          variant="contained"
                          type="submit"
                          disabled={values.isSubmit}
                        >
                          Submit
                        </Index.Button>
                      </Index.Box>
                    </Index.Grid>
                  </Index.Grid>
                </Index.Box>
              </form>
            )}
          </PagesIndex.Formik>
        </Index.Box>
      </Index.Box>
    </>
  );
};

export default DonnerTypeAdd;